import { useEffect, useRef } from 'react';
import H from '@here/maps-api-for-javascript';
import withTranslation from 'hoc/withTranslation';
import { getStartEndFeatures, updateStartEndGroupMarkers } from './utils/startEndLocationsFactory';
import { attachStartEndHoverEvents } from './utils/startEndLocationEvents';

const NewStartEndLocations = ({ translations, map, geoJSON, ui, user, display }) => {
  const groupRef = useRef(null);
  const translationsRef = useRef(translations);

  useEffect(() => {
    translationsRef.current = translations;
  });

  useEffect(() => {
    if (map) {
      groupRef.current = new H.map.Group();
      map.addObject(groupRef.current);
    }
    return () => {
      if (groupRef.current) {
        groupRef.current.removeAll();
        map.removeObject(groupRef.current);
        groupRef.current = null;
      }
    };
  }, [map]);

  useEffect(() => {
    if (!groupRef.current || !ui.current) return;

    if (!geoJSON?.geo?.features || geoJSON.geo.features.length === 0) {
      groupRef.current.removeAll();
      return;
    }

    if (!user?.mapSettings?.showStops) {
      groupRef.current.removeAll();
      return;
    }

    const features = getStartEndFeatures(geoJSON, display, !display?.showProblem);

    if (features.length === 0) {
      groupRef.current.removeAll();
      return;
    }

    updateStartEndGroupMarkers(
      features,
      groupRef.current,
      translationsRef,
      map,
      attachStartEndHoverEvents,
    );
  }, [geoJSON, map, ui, display, user]);

  return null;
};

export default withTranslation(NewStartEndLocations);
